<template>
  <v-app>
    <v-app-bar app flat class="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 mt-5">
      <div class="container1400">
        <v-container fluid v-if="payments">
          <v-alert
            v-if="$store.state.user.prefered_currency != payments.currency_code"
            outlined
            color="error"
            prominent
            border="left"
          >
            <div class="text-center">{{ $t("s1654625698") }}</div>
            <v-divider class="my-4 error" style="opacity: 0.22"></v-divider>
            <div class="text-right">
              <v-btn
                href="https://member.nomadrooms.com/checkout"
                target="_blank"
                color="error"
                outlined
              >
                {{ $t("s1655386049") }}
              </v-btn>
            </div>
          </v-alert>
          <v-row>
            <v-col cols="6" md="6">
              <v-card flat>
                <v-card-text>
                  <div class="text-h5 pa-5">{{ $t("Billingdetails") }}</div>
                  <v-simple-table class="ml-5 mr-5 mb-10 grey lighten-4">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td>
                            {{ $t("Tripid") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ parm }}
                          </td>
                        </tr>
                        <tr v-if="payments.payment">
                          <td>
                            {{ $t("BookingAmount") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }} {{ payments.payment }}
                          </td>
                        </tr>
                        <tr v-if="payments.security_deposit > '0'">
                          <td>
                            {{ $t("Securitydeposit") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }}
                            {{ payments.security_deposit }}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            {{ $t("BookingFee") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }}
                            {{ payments.nomad_fee }}
                          </td>
                        </tr>
                        <tr v-if="payments.cleaning_fee > '0'">
                          <td>
                            {{ $t("CleaningFee") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }}
                            {{ payments.cleaning_fee }}
                          </td>
                        </tr>
                        <tr v-if="payments.membership_fee > '0'">
                          <td>
                            {{ $t("BA2") }}
                            <v-tooltip v-model="show" top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  href="https://member.nomadrooms.com/terms/membership-fees/"
                                  target="_blank"
                                  icon
                                  v-bind="attrs"
                                  v-on="on"
                                  class="ml-1"
                                >
                                  <v-icon color="light-blue">
                                    mdi-information
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("BA1") }}</span>
                            </v-tooltip>
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }}
                            {{ payments.membership_fee }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-weight-bold">
                            {{ $t("Amountpayableis") }}
                          </td>
                          <td class="font-weight-bold text-right">
                            {{ payments.currency_code }}
                            {{
                              (
                                parseFloat(payments.membership_fee) +
                                parseFloat(payments.security_deposit) +
                                parseFloat(payments.cleaning_fee) +
                                parseFloat(payments.nomad_fee) +
                                parseFloat(payments.payment)
                              ).toFixed(2)
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card flat>
                <v-card-text>
                  <div class="text-h5 pa-5">{{ $t("s1647814250") }}</div>
                  <div class="px-5">
                    <v-row class="pb-10">
                      <v-col cols="4">
                        <v-sheet
                          dark
                          color="light-blue"
                          elevation="0"
                          width="100%"
                          class="px-5 py-3"
                        >
                          <v-icon>mdi-credit-card</v-icon>
                          <div class="subtitle-1">{{ $t("Card") }}</div>
                        </v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          dark
                          color="grey lighten-4"
                          elevation="0"
                          width="100%"
                          height="100%"
                          class="px-5 py-3"
                        >
                        </v-sheet>
                      </v-col>
                      <v-col cols="4">
                        <v-sheet
                          dark
                          color="grey lighten-4"
                          elevation="0"
                          width="100%"
                          height="100%"
                          class="px-5 py-3"
                        >
                        </v-sheet>
                      </v-col>
                    </v-row>
                    <stripe-element-card
                      ref="elementRef"
                      :pk="privateKey"
                      @token="tokenCreated"
                      :elementStyle="elemStyle"
                      hidePostalCode
                    />
                  </div>
                  <div class="px-5 pt-5 text-right">
                    <v-btn
                      color="blue white--text darken-3"
                      rounded
                      @click.prevent="submit"
                    >
                      <span class="mr-2">{{ $t("Pay") }}</span
                      >{{ payments.currency_code }}
                      {{
                        (
                          parseFloat(payments.membership_fee) +
                          parseFloat(payments.security_deposit) +
                          parseFloat(payments.cleaning_fee) +
                          parseFloat(payments.nomad_fee) +
                          parseFloat(payments.payment)
                        ).toFixed(2)
                      }}
                    </v-btn>
                  </div>
                  <div class="px-5 pt-5 text-center">
                    <img
                      class="badge-image"
                      src="../../assets/images/stripe-badge-white.png"
                      alt="Stripe badge"
                    />
                  </div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- Please stand by dialog -->
      <v-dialog v-model="waitDialog" persistent width="50%">
        <v-card color="blue" dark>
          <v-card-text class="pt-5">
            <div class="subtitle-1 text-center pb-3">
              {{ $t("PleaseStandBy") }}
            </div>
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Please stand by dialog -->
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
import timeoutMixin from "@/mixins/timeoutMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import BookingService from "@/services/BookingService";
import { StripeElementCard } from "@vue-stripe/vue-stripe";
import { format } from "date-fns";

export default {
  name: "CompleteBooking",
  mixins: [timeoutMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    StripeElementCard
  },
  data() {
    return {
      format,
      show: false,
      parm: this.$route.params.id,
      payments: "",
      waitDialog: false,
      elemStyle: {
        base: {
          iconColor: "#000",
          fontWeight: "500",
          fontFamily: "Poppins, sans-serif",
          fontSize: "18px",
          lineHeight: "50px",
          padding: "20px 10px"
        }
      },
      privateKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY
    };
  },
  created: function() {
    BookingService.viewPayment({
      booking_id: this.parm
    })
      .then(result => {
        this.payments = result.data;
        if (this.payments.booking_status != "bs0") {
          this.$router.push({
            name: "ViewBooking",
            params: { id: this.parm }
          });
        }
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    pay() {
      this.$refs.paymentRef.submit();
    },
    tokenCreated(token) {
      this.waitDialog = true;
      BookingService.stripePayment({
        token,
        booking_id: this.parm
      })
        .then(() => {
          this.waitDialog = false;
          this.$router.push({
            name: "ViewBooking",
            params: { id: this.parm }
          });
        })
        .catch(err => {
          this.error = err.response.data.errors;
          this.waitDialog = false;
        });
    },
    submit() {
      this.$refs.elementRef.submit();
    }
  }
};
</script>

<style>
.vue-tel-input-vuetify .v-text-field .v-select__selections .vti__flag {
  margin-left: 5px !important;
}
.badge-image {
  width: 100%;
  height: auto;
  max-width: 500px;
}
#stripe-element-mount-point {
  height: auto;
  border-color: #dedfe3;
}
</style>
